import React from 'react';
import { Outlet } from "react-router-dom";
import Header from '../../components/website/header/header';
import Footer from '../../components/website/footer/footer';

const WebsiteLayout = () => {
    return (
        <div className='website_container'>
            <header>
                <Header/>
            </header>
            <main>
                <Outlet/>
            </main>
            <footer>
                <Footer/>
            </footer>
        </div>
    );
};

export default WebsiteLayout;